import { API_NEW } from 'src/API';
import { RelationFieldType } from '.';

export interface Select2WebElementModel {
	id: string;
	text: string;
	attrs: string[];
	metaData: { [key: string]: any };
}

export interface EntityRequestModel {
	page: number;
	skipPageCount: number;
	pageSize: number;
	searchString: string;
	option: string;
}

class API extends API_NEW {
	/**
	 * Запрос за списком опций ( элементами выпадающих списков )
	 * @param relation Тут описываются данные для загрузки списка
	 * @param searchString Поисковая строка
	 * @param page Страница
	 * @param skipCount Сколько элементов пропустить
	 * @param additionData Дополнительные данные, которые вкрячутся в урл и данные формы
	 * ( иногда нужны для доп. фильтрации )
	 * @returns массив элементов
	 */
	static getOptions = async (
		relation: RelationFieldType,
		searchString: string,
		page: number = 0,
		skipCount: number = 0,
		additionData?: any,
		pageCount?: number,
	) => {
		const method = relation.method ?? 'get';
		const url = new URL(window.host + relation.url);
		if (method === 'get') {
			!!searchString &&
				url.searchParams.append('term', searchString.toLowerCase());
			!!page && url.searchParams.append('SkipPageCount', page.toString());
			!!pageCount &&
				url.searchParams.append('TakeCount', pageCount.toString());
		}

		const frm = new FormData();
		if (page) {
			frm.append('page', page.toString());
		}
		if (skipCount) {
			frm.append('skipPageCount', skipCount.toString());
		}
		if (searchString) {
			frm.append('searchString', searchString);
		}

		if (additionData) {
			for (const key in additionData) {
				if (!Object.hasOwn(additionData, key)) {
					continue;
				}
				const value = additionData[key];
				if (method === 'get') {
					url.searchParams.append(key, value);
				}
				frm.append(key, value);
			}
		}

		return this.onRequest<Array<Select2WebElementModel>>({
			url: url.toString(),
			method: method,
			data: frm,
		});
	};
}

export default API;
